import { createRoot } from "react-dom/client";
import "./index.css";
import "./styles/design-routines.css";
import "./styles/motion-design-system-bridge.css";
import "./styles/ui-motion.css";
import App from "./App.tsx";

createRoot(document.getElementById("root")!).render(<App />);
